/** @format */

import {Box, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

import {ErrorBlockType} from './interfaces';

interface StyledErrorProps {
  type: ErrorBlockType;
}

export const StyledErrorBlock = styled(Box, {
  shouldForwardProp: prop => prop !== 'type',
})<StyledErrorProps>(({theme, type}) => ({
  border: `2px solid ${
    type === 'error' ? theme.palette.error_secondary?.main : theme.palette.warning.main
  }`,
  borderRadius: '8px',
  padding: theme.spacing(3),
  backgroundColor: 'transparent',
  color: theme.palette.text.primary,
  maxWidth: '500px',
}));

export const ErrorTitle = styled(Typography, {
  shouldForwardProp: prop => prop !== 'type',
})<StyledErrorProps>(({theme, type}) => ({
  fontSize: '14px',
  fontWeight: 700,
  marginBottom: theme.spacing(2),
  color: type === 'error' ? theme.palette.error_secondary?.main : theme.palette.warning.main,
}));

export const ErrorDescription = styled(Typography)(({theme}) => ({
  fontSize: '14px',
  color: theme.palette.figma_gray_light_1?.main,
}));

export const ErrorAdditionalInfo = styled(Typography)(({theme}) => ({
  marginTop: theme.spacing(2),
}));
